import React from 'react';

import { Dialog, DialogContent } from '@material-ui/core';
import { FiLoader } from 'react-icons/fi';

import './styles.css';

export default function Load({ loading, message }) {
  return (
    <Dialog open={loading}>
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '25px',
        }}
      >
        <FiLoader className='rotating' />
        <span style={{ marginTop: '0.5em' }}>
          {message ? message : 'Carregando...'}
        </span>
      </DialogContent>
    </Dialog>
  );
}
